<header
  class="topbar mtm-glass"
  [class.topbar--detail]="crumbs().length > 2 || !!shell.breadcrumbDetail()"
  [class.topbar--with-page-actions]="!!shell.headerActions()"
>
  <button
    type="button"
    class="topbar__menu"
    [attr.aria-label]="'SIDEBAR.OPEN_MENU' | translate"
    [attr.aria-expanded]="shell.mobileNavOpen()"
    (click)="shell.mobileNavOpen.set(true)"
  >
    <mtm-icon name="menu" [size]="18" />
  </button>

  <nav class="topbar__crumbs" [attr.aria-label]="'TOPBAR.BREADCRUMB' | translate">
    <ol>
      @for (crumb of crumbs(); track crumb.labelKey; let last = $last) {
        <li>
          @if (crumb.link) {
            <a [routerLink]="crumb.link" [queryParams]="crumb.queryParams">{{
              crumb.labelKey | translate: crumb.labelParams
            }}</a>
          } @else {
            <span
              [class.topbar__current]="last && !shell.breadcrumbDetail()"
              [attr.aria-current]="last && !shell.breadcrumbDetail() ? 'page' : null"
              >{{ crumb.labelKey | translate: crumb.labelParams }}</span
            >
          }
        </li>
      }
      @if (shell.breadcrumbDetail(); as detail) {
        <li>
          <span class="topbar__current mtm-data" aria-current="page">{{ detail }}</span>
        </li>
      }
    </ol>
  </nav>

  <div class="topbar__actions">
    @if (shell.headerActions(); as actions) {
      <div class="topbar__page-actions">
        <ng-container [ngTemplateOutlet]="actions" />
      </div>
    }
    <mtm-theme-toggle />

    <div class="topbar__lang" role="group" [attr.aria-label]="'TOPBAR.LANGUAGE' | translate">
      @for (lang of languages; track lang.code) {
        <button
          class="topbar__lang-btn"
          [class.topbar__lang-btn--active]="currentLang() === lang.code"
          [attr.aria-pressed]="currentLang() === lang.code"
          type="button"
          (click)="switchLang(lang.code)"
        >
          {{ lang.label }}
        </button>
      }
    </div>
  </div>
</header>
